var _g, _path, _path2, _path3, _path4, _g2, _g3, _path5, _path6, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadePopular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 125,
    viewBox: "0 0 243 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_597:6141)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169 63.5C169 63.5 148.629 92 123.5 92C98.3711 92 78 63.5 78 63.5C78 63.5 98.3711 35 123.5 35C148.629 35 169 63.5 169 63.5ZM144.266 63.5C144.266 74.9519 134.969 84.2357 123.5 84.2357C112.031 84.2357 102.733 74.9519 102.733 63.5C102.733 52.0481 112.031 42.7643 123.5 42.7643C134.969 42.7643 144.266 52.0481 144.266 63.5ZM123.5 75.3821C130.072 75.3821 135.4 70.0623 135.4 63.5C135.4 56.9377 130.072 51.6179 123.5 51.6179C116.928 51.6179 111.6 56.9377 111.6 63.5C111.6 70.0623 116.928 75.3821 123.5 75.3821Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.636 63.5216C78.6306 63.5143 78.6252 63.5071 78.62 63.5C78.6252 63.4929 78.6306 63.4857 78.636 63.4784C78.7894 63.2724 79.0183 62.9691 79.3191 62.5824C79.9206 61.8089 80.8092 60.7022 81.9544 59.3733C84.2453 56.7148 87.5598 53.1708 91.6538 49.6281C99.8575 42.5292 111.117 35.5 123.5 35.5C135.883 35.5 147.143 42.5292 155.346 49.6281C159.44 53.1708 162.755 56.7148 165.046 59.3733C166.191 60.7022 167.079 61.8089 167.681 62.5824C167.982 62.9691 168.211 63.2724 168.364 63.4784C168.369 63.4857 168.375 63.4929 168.38 63.5C168.375 63.5071 168.369 63.5143 168.364 63.5216C168.211 63.7276 167.982 64.0309 167.681 64.4176C167.079 65.1911 166.191 66.2978 165.046 67.6267C162.755 70.2852 159.44 73.8292 155.346 77.3719C147.143 84.4708 135.883 91.5 123.5 91.5C111.117 91.5 99.8575 84.4708 91.6538 77.3719C87.5598 73.8292 84.2453 70.2852 81.9544 67.6267C80.8092 66.2978 79.9206 65.1911 79.3191 64.4176C79.0183 64.0309 78.7894 63.7276 78.636 63.5216ZM123.5 84.7357C135.245 84.7357 144.766 75.2288 144.766 63.5C144.766 51.7712 135.245 42.2643 123.5 42.2643C111.755 42.2643 102.233 51.7712 102.233 63.5C102.233 75.2288 111.755 84.7357 123.5 84.7357ZM134.9 63.5C134.9 69.7854 129.797 74.8821 123.5 74.8821C117.203 74.8821 112.1 69.7854 112.1 63.5C112.1 57.2146 117.203 52.1179 123.5 52.1179C129.797 52.1179 134.9 57.2146 134.9 63.5Z",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26042 0L0.63623 50H12.6109L22.138 0H5.26042Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2325 0H23.5765L18.5381 21.0423L24.3522 50H34.5721L29.2325 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597:6141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26042 0L0.63623 50H12.6109L22.138 0H5.26042Z",
    fill: "#A98AD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2325 0H23.5765L18.5381 21.0423L24.3522 50H34.5721L29.2325 0Z",
    fill: "#A98AD1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597:6141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.0103 -2.21234C1.92269 1.24429 7.78869 9.82685 7.78869 16.504C7.78869 23.1812 -1.65084 15.0371 -6.37061 10.1304",
    stroke: "#6BBE56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.523 62.3894C10.8858 49.115 5.35487 31.8584 7.34602 25.2212C9.33717 18.584 11.1071 46.4602 -0.839844 28.5398",
    stroke: "#6BBE56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1421 55.0885C28.1421 48.0088 28.5846 34.6017 30.3545 37.6106C32.5669 41.3717 33.6731 54.2035 36.9916 55.0885",
    stroke: "#6BBE56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.91205,
    cy: 44.0265,
    r: 1.49115,
    stroke: "#6BBE56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8501 35.8407C24.1598 31.4159 29.6908 30.9734 20.8412 41.8141M20.1775 -1.54869C19.1451 1.25367 16.4164 8.05308 13.7616 12.8318C10.443 18.8053 10.4429 3.31856 14.8677 -5.30975",
    stroke: "#6BBE56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4077 35.8408C21.4313 31.0473 27.4343 19.6903 27.2573 12.6107C27.036 3.76113 19.5139 33.1859 35.0006 12.6107",
    stroke: "#6BBE56"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_597:6141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.149 85H207.867L196 97.1836L203.024 102.914L209.315 99.0174L205.777 125H234.056L231.739 113.752L213.149 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.485 85H225.196L219.28 92.6843L231.058 110.968L229.037 99.0174L235.328 102.914L242.352 97.1836L230.485 85Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_597:6141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 85,
    width: 47,
    height: 40
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.149 85H207.867L196 97.1836L203.024 102.914L209.315 99.0174L205.777 125H234.056L231.739 113.752L213.149 85Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.485 85H225.196L219.28 92.6843L231.058 110.343L229.037 99.0174L235.328 102.914L242.352 97.1836L230.485 85Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_597:6141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.593 81.3071C202.377 85.8002 198.389 98.2579 200.161 112.143",
    stroke: "#72BF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.917 81.3071C206.071 83.5844 202.932 91.7213 205.147 106.05C207.917 123.961 195.176 126.177 194.253 127.285",
    stroke: "#72BF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24 81.4917C209.455 83.3997 206.956 89.8378 211.24 100.326C216.595 113.436 213.086 128.947 209.578 132.086",
    stroke: "#72BF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.118 81.6765C213.148 84.1384 210.945 91.2413 217.888 99.9567C226.566 110.851 226.566 121.93 225.828 129.131",
    stroke: "#72BF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.623 82.486C220.638 85.9328 220.368 93.1956 227.163 94.6728C235.657 96.5193 242.488 95.9654 245.258 104.644",
    stroke: "#72BF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.447 81.0514C222.139 84.7443 224.367 91.9087 235.741 91.0224",
    stroke: "#72BF52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_597:6141",
    x: 74,
    y: 31,
    width: 99,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_597:6141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_597:6141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_597:6141",
    x: 192,
    y: 81,
    width: 54.3521,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_597:6141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_597:6141",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadePopular);
export default __webpack_public_path__ + "static/media/facade-popular.86581320.svg";
export { ForwardRef as ReactComponent };